import { TabBookingAbstract } from './tabBookingAbstract'
import { dateCompare, ensureExecuteSuccess } from '@/utils/commonUtil'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { TabError } from '@/utils/class/TabError'
import { getOverseaAgentGradeByCode } from '@/class/cargo/model/parameters/OverseaAgentGrade'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import DateUtils from '@/utils/dateUtils'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import { Company } from '@/class/model/mdm/Company'
import { Customer } from '@/class/model/mdm/Customer'
import { OverseaAgent } from '@/class/model/sys/OverseaAgent'
import { CreditInfo } from '@/class/model/sys/CreditInfo'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import { TruckingInfo } from '@/class/model/booking/TruckingInfo'
import { WarehouseInfo } from '@/class/model/booking/WarehouseInfo'
import {
  batchDeleteJob,
  batchRemoveJob,
  batchAddJob,
  getSeaExportJobByUuid,
  checkJobForShared
} from '@/api/seaExport/seaExportJob'
import { canCreateByCreditInfoDetail } from '@/api/partner/creditInfo'
import { getUserPortByCode } from '@/api/userPort'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { sortByMultiField } from '@/utils'
import { getObjectByCache, getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import StrUtils from '@/utils/StrUtils'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import { BackUpWarehouseInfo } from '@/class/model/booking/BackUpWarehouseInfo'
import { getBackUpWarehouseCompany, getWarehouseDetail } from '@/api/company'
import { getUserDefaultDepartment } from '@/api/user'
import ColumnUtils from '@/utils/ColumnUtils'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'
import { CreditInfoUtil } from '@/class/cargo/model/utils/CreditInfoUtil'
import { cache } from '@/utils/cacheManager'
import $store from '@/store'

export class TabBookingMasterPM extends TabBookingAbstract {
  /**
   * @param {Object} view 视图
   */
  constructor(view) {
    super(view)
    this.isWithinCloseAccountDate = false // withinCloseAccountDate
    this.sEUseDischargingPort5Code = false // 装箱单是否使用卸港5字码
    this.selectWindow = null
    this.queryLclWindow = null
    this.removedSubJobs = []
    this.removeSubJob = null
    this.formInitialValue = {} // 表单的初始值（用于判断表单字段是否被修改）
    this.loadingAgentIdArray = [] // 起运港代理下拉框数据源
  }
  get salesOfficeCheck() {
    return this.view.salesOfficeCheck
  }
  set salesOfficeCheck(salesOfficeCheck) {
    this.view.salesOfficeCheck = salesOfficeCheck
  }
  get branchOfficeCheck() {
    return this.view.branchOfficeCheck
  }
  set branchOfficeCheck(branchOfficeCheck) {
    this.view.branchOfficeCheck = branchOfficeCheck
  }
  init() {
    this.canChangeSalesOfJob = Number(this.config.get('canChangeSalesOfJob')) === 1
    this.isJoinCarrierBookingAgent = Number(this.config.get('CarrierBookingAgentJoin')) === 1
    this.isJoinPortDestinationAgent = Number(this.config.get('PortDestinationAgentJoin')) === 1
    this.sEUseDischargingPort5Code = this.config.get('SEUseDischargingPort5Code') === '1'
    this.IsSpecifiedSalesBusiness = Number(this.config.get('IsSpecifiedSalesBusiness')) === 1
    this.useUserPort = parseInt(this.config.get('useUserPort')) === 1
    JobUtils.getTransportationModeAll(this.view.form).then(res => {
      this.view.transportationModeInfos = res
    })
    // 起运港代理下拉框赋值
    Company.getCmpIdxByLocal({ branchId: this.context.office.officeId }).then(res => {
      this.loadingAgentIdArray = res
    })
  }
  changeJob() {
    if (this.job.uuid) {
      this.view.txtWhs = JobUtils.getWarehouseInDetail(this.job.warehouseIn)
    }
    const warehouseInfo = this.job.warehouseInfo
    if (warehouseInfo.length > 0) {
      this.job.warehouseCmp = warehouseInfo[0].warehouseCmp
    }
    const trucking = this.job.trucking
    if (trucking.length > 0) {
      // 需要排序，因为业务调整更新的 TruckingId desc排序后的第一条，要及时反馈出来
      sortByMultiField(trucking, ['truckingId'], true)
      this.job.carryingCmp = trucking[0].carryingCmp
    }
    this.loadIsWithinClosingAccountDate()
    ContainerUtil.refreshContainerSeaEQ(this.job)
    this.formInitialValue = { ...this.job }
    this.loadBackUpWarehouseCmp()
  }
  fillView() {
    const job = this.job
    if (!job.uuid) {
      if (!job.containerLoadType) {
        job.containerLoadType = 'LCL'
      }
      job.signMBL = true
      ensureExecuteSuccess(() => {
        return !!this.view.$refs.customJobType
      }).then(() => {
        this.selectDefaultCutomJobType()
      })
      this.carrierAgentSyncLoading()
      // CARGO-969 利通：填写目的港代理之后，MBL收货人地址带不出来
      if (job.lob === 'SE' && job.masterFlag) {
        job.mblOnly = false
      }
      // this.loadUserPort(job.dischargingPortCode)
      JobUtils.matchUserPortConfig(this.view, job)
      JobUtils.matchRegionWarehouseMappingConfig(job, warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData, true)
    } else {
      JobUtils.matchUserPortConfig(this.view, job, false, null, { keepOriginValue: true })
    }

    this.getSailingDay()
    this.loadCompanyOffice()
    this.loadOverseaOpChanged()
    this.loadOverseaAgentChanged()
    this.loadWarehouseRegion(false)
    this.loadBackUpWarehouseCompany()
    this.setPlannerChange()
  }
  checkValueMatch() {
    const seaport = getObjectByCache(basicCacheKeys.basic_data_Seaport, 'code', this.job.destinationPortCode)
    if (!seaport) {
      this.job.destinationPortCode = ''
    }
  }
  async fillModel() {
    const model = this.job
    if (model.containerLoadType !== 'BC') {
      model.customerId = 0
      model.customerContact = ''
    }
    model.signMBL = true
    // 仓库
    this.getWarehouseInfo()
    // 车队
    this.getTruckingInfo()
    // 刷新小票的POL、POD、ETD、ETA、ATA、Vessel、Voyage、订舱代理、carrier、sailingDay
    for (const slave of model.lclSlaves) {
      if (slave.loadingPortCode !== model.loadingPortCode) {
        slave.loadingPortCode = model.loadingPortCode
      }
      if (slave.etd !== model.etd) {
        slave.etd = model.etd
        slave.sailingDay = model.sailingDay
      }
      if (slave.eta !== model.eta) {
        slave.eta = model.eta
      }
      if (slave.ata !== model.ata) {
        slave.ata = model.ata
      }
      if (slave.vessel !== model.vessel) {
        slave.vessel = model.vessel
      }
      if (slave.bookingAgent !== model.bookingAgent) {
        slave.bookingAgent = model.bookingAgent
      }
      if (slave.carrierId !== model.carrierId) {
        slave.carrierId = model.carrierId
      }
      if (slave.warehouseCmp !== model.warehouseCmp) {
        slave.warehouseCmp = model.warehouseCmp
      }
      this.addLclSlaveToModifiedSet(slave)
    }
    // 同步报关行
    JobUtils.synCustomsBroker(model, Number(model.customsBroker))
    const job = new SeaExportJob(this.job)
    const hdoc = await job.getCargoDocByType('HBL', false)
    const mdoc = await job.getCargoDocByType('MBL', true)
    if (!mdoc.uuid) {
      await CargoDocUtil.initMBLProperties(mdoc, this.job, this.view.action)
      await JobUtils.handlerCargoDocLinebreaks(mdoc)
      if (hdoc) {
        await CargoDocUtil.initHBLProperties(hdoc, this.job)
        this.addCargoDocToModifiedSet(hdoc)
      }
      await CargoDocUtil.checkOverseaAgentProperties(job)
    }
    const oldJob = this.formInitialValue
    if (job.quantityActual !== oldJob.quantityActual || job.weightActual !== oldJob.weightActual ||
      job.cubageActual !== oldJob.cubageActual || job.chargeWeight !== oldJob.chargeWeight) {
      CargoDocUtil.changeJobSynToBillOfLading(job, mdoc)
    }
    if (this.view.isEdit && model.insideQuantity > 0) {
      mdoc.insideQuantity = model.insideQuantity
    }
    const billOfLadingSynMode = parseInt(this.config.get('BillOfLadingSynMode'))
    if (model.packing && [1, 2].includes(billOfLadingSynMode)) {
      mdoc.packing = model.packing
    }
    if (!model.uuid) {
      if (model.quantityActual > 0) {
        mdoc.quantitySum = this.getQuantitySum(Number(model.quantityActual), model.packing)
      } else {
        mdoc.quantitySum = this.getQuantitySum(Number(model.quantityContract), model.packing)
      }
      // 包装显示名
      if (model.packing && !mdoc.packingName && [1, 2].includes(billOfLadingSynMode)) {
        const packing = this.context.packingList.find(p => p.code === model.packing)
        mdoc.packingName = packing ? packing.name : ''
      }
    }
    model.cargoCode = this.view.form.cargoCode
    model.cargoName = this.view.form.cargoName
    this.addCargoDocToModifiedSet(mdoc)
    // CARGO-31231 品名/唛头同步提单参数覆盖主票场景
    const seaCargoMark = parseInt(this.config.get('seaCargoMark'))
    const seaCargoEnglishName = parseInt(this.config.get('seaCargoEnglishName'))
    // 是否太平
    const isTp = String(cache.config.get('ToExoSystem')) === 'TP'
    // 唛头最大字符数
    const sEMarkMaxChars = parseInt(this.config.get('SEMarkMaxChars'))
    // 英文品名最大字符数
    const sEEnglishDescriptionOfGoodsMaxchars = parseInt(this.config.get('SEEnglishDescriptionOfGoodsMaxchars'))
    if (mdoc) {
      if (!mdoc.uuid || !mdoc.mark || ([1, 2].indexOf(seaCargoMark) > -1 && job.mark !== oldJob.mark)) {
        if (isTp) {
          mdoc.mark = JobUtils.splitStringByBrAndLength(job.mark, sEMarkMaxChars, 'r')
        } else {
          mdoc.mark = job.mark
        }
      }
      if (!mdoc.uuid || !mdoc.cargoEnglishName || ([1, 2].indexOf(seaCargoEnglishName) > -1 && job.cargoEnglishName !== oldJob.cargoEnglishName)) {
        if (isTp) {
          mdoc.cargoEnglishName = JobUtils.splitStringByBrAndLength(job.mark, sEEnglishDescriptionOfGoodsMaxchars, 'r')
        } else {
          mdoc.cargoEnglishName = job.cargoEnglishName
        }
      }
    }
  }
  // 获取开航日期后面的星期几
  getSailingDay() {
    if (this.job.etd) {
      this.job.sailingDay = String(new Date(this.job.etd)).substr(0, 3).toUpperCase()
    } else {
      this.job.sailingDay = ''
    }
  }
  // 添加cargoDoc到被修改的集合中
  addCargoDocToModifiedSet(cargoDoc) {
    // 主票没有HBL, 只有一个MBL
    if (cargoDoc.docType === 'HBL') return
    const modifiedData = this.context.modifiedData
    modifiedData.seaCargoDoc = modifiedData.seaCargoDoc || []
    let mDoc = null
    if (modifiedData.seaCargoDoc && modifiedData.seaCargoDoc.length > 0) {
      for (const seaCargoDoc of modifiedData.seaCargoDoc) {
        if (seaCargoDoc.docType === 'MBL') {
          mDoc = seaCargoDoc
          break
        }
      }
    }
    if (mDoc) {
      Object.assign(mDoc, cargoDoc)
      return
    }
    if (!modifiedData.seaCargoDoc.includes(cargoDoc)) {
      modifiedData.seaCargoDoc.push(cargoDoc)
    }
  }
  // 添加小票信息到被修改的集合中
  addLclSlaveToModifiedSet(slave) {
    const modifiedData = this.context.modifiedData
    modifiedData.lclSlaves = modifiedData.lclSlaves || []
    if (!modifiedData.lclSlaves.includes(slave)) {
      modifiedData.lclSlaves.push(slave)
    }
  }
  async validateForm() {
    const job = this.job
    await JobUtils.checkCustomerBranchScope(job, 'tabBookingMaster')
    if (Number(job.bookingAgent) < 1) {
      throw new TabError(this.view.$t('Message.BookingAgentCannotBeNull'), 'tabBookingMaster')
    }
    if (!job.loadingPortCode || !this.checkSeaport(job.loadingPortCode)) {
      throw new TabError(this.view.$t('Message.POLCannotBeNull'), 'tabBookingMaster')
    }
    if (job.transfering && (!job.transferPortCode || !this.checkSeaport(job.transferPortCode))) {
      throw new TabError(this.view.$t('Message.IfThereIsATransferTheTransferPortCannotBeNull'), 'tabBookingMaster')
    }
    if (!job.dischargingPortCode || !this.checkSeaport(job.dischargingPortCode)) {
      throw new TabError(this.view.$t('Message.PortOfDischargeCannotBeNull'), 'tabBookingMaster')
    }
    if (!job.destinationPortCode || !this.checkSeaport(job.destinationPortCode)) {
      throw new TabError(this.view.$t('Message.PlaceOfDeliveryCannotBeNull'), 'tabBookingMaster')
    }
    if (job.cargoSource === 'NC' && Number(job.designationAgent) === 0) {
      throw new TabError(this.view.$t('Message.NominatedAgentCannotBeNull'), 'tabBookingMaster')
    }
    if (!job.etd) {
      throw new TabError(this.view.$t('Message.DateOfDepartureCannotBeNull'), 'tabBookingMaster')
    }
    if (job.etd && job.eta && job.eta < job.etd) {
      throw new TabError(this.view.$t('Message.DateOfDepartureCannotBeLaterThanDateOfArrival'), 'tabBookingMaster')
    }
    if (Number(job.opDepartment) === 0) {
      throw new TabError(this.view.$t('SeaExport.OperationDepartmentCannotBeEmpty'), 'tabBookingMaster')
    }
    // 截关日期不能大于开航日期
    if (job.customCutoff) {
      const etd = new Date(job.etd)
      const customCutoff = new Date(job.customCutoff)
      const diff = DateUtils.getBetweenDays(customCutoff, etd)
      if (diff < 0) {
        throw new TabError(this.view.$t('Message.CyCutoffDateCannotBeLaterThanDepartureDate'), 'tabBookingMaster')
      }
    }
    // 驳船截关日期不能大于截关日期
    if (job.bargeCustomCutoff && job.customCutoff) {
      const customCutoff = new Date(job.customCutoff)
      const bargeCustomCutoff = new Date(job.bargeCustomCutoff)
      const diff = 365 * (customCutoff.getFullYear() - bargeCustomCutoff.getFullYear()) + 31 * (customCutoff.getMonth() - bargeCustomCutoff.getMonth()) +
        (customCutoff.getDate() - bargeCustomCutoff.getDate())
      if (diff < 0) {
        throw new TabError(this.view.$t('Message.BargeCutoffDateCannotBeLaterThanCyCutoffDate'), 'tabBookingMaster')
      }
    }
    const seaEQList = this.view.form.seaEQ
    if (!seaEQList || seaEQList.length === 0) {
      throw new TabError(this.view.$t('Message.EQSizeCannotBeNull'), 'tabBookingMaster')
    }
    if (seaEQList && seaEQList.length > 0) {
      if (new Set(seaEQList).size < seaEQList.length) {
        throw new TabError(this.view.$t('SeaExport.RepeatBoxType'), 'tabBookingMaster')
      }
      if (job.containerLoadType === ContainerLoadType.LCL_CARGO_TYPE.code || job.containerLoadType === ContainerLoadType.BC_CARGO_TYPE_FCL.code) {
        if (ContainerUtil.checkNoDuplationSeaEQ(this.view.form)) {
          throw new TabError(this.view.$t('SeaExport.RepeatBoxType'), 'tabBookingMaster')
        }
      }
    }
    if (Number(job.sales) > 0 && Number(job.salesDepartment) <= 0) {
      throw new TabError(this.view.$t('Message.SalesDepartmentIsNullPleaseReSelectSales'), 'tabBookingMaster')
    }
    if (this.view.form.customerId > 0 && !SecurityUtil.customerIsOwn(this.view.form.customerId) && !this.view.form.uuid) {
      throw new TabError(this.view.$t('CargoMsg.Cargo_CustomerNotOwn'), 'tabBookingMaster')
    }
    let isOk = true
    if (job.sales && job.sales === job.op) {
      isOk = await this.view.$confirm(this.view.$t('SeaExport.SalesAndOperationAreSame'), this.view.$t('SeaExport.Confirm'), {
        confirmButtonText: this.view.$t('common.btn.yes'),
        cancelButtonText: this.view.$t('common.btn.no'),
        type: 'warning'
      }).then(() => true).catch(() => false)
    }
    // if (isOk) {
    //   isOk = await this.checkCargoSource()
    // }
    if (!isOk) {
      throw new TabError('', 'tabBookingMaster')
    }
    // 中邮定制字段 保存校验
    if (this.view.isZY && !job.saleProductCode) {
      throw new TabError(this.view.$t('Message.SaleProductCodeCannotBeNull'), 'tabBookingMaster')
    }
    if (this.view.isZY && !job.fullOrInside) {
      throw new TabError(this.view.$t('Message.FullOrInsideCannotBeNull'), 'tabBookingMaster')
    }
  }
  // 校验海港
  checkSeaport(code) {
    const obj = getObjectByCache(basicCacheKeys.basic_data_Seaport, 'code', code)
    return Boolean(obj)
  }
  // async checkCargoSource() {
  //   const job = this.job
  //   if (job.masterFlag) {
  //     let notSame = false
  //     await new SeaExportJob(job).getLclSlaves()
  //     for (const slave of job.lclSlaves) {
  //       if (slave.cargoSource !== job.cargoSource) {
  //         notSame = true
  //         break
  //       }
  //     }
  //     if (notSame) {
  //       return await this.view.$confirm(this.view.$t('SeaExport.PickUpTypeDifferentSmallTicket'), this.view.$t('SeaExport.Confirm'), {
  //         confirmButtonText: this.view.$t('common.btn.yes'),
  //         cancelButtonText: this.view.$t('common.btn.no'),
  //         type: 'warning'
  //       }).then(() => true).catch(() => false)
  //     }
  //   }
  //   return true
  // }
  /**
 * 关账后，基本页面里的销售公司、销售员、操作部门不允许修改
 */
  loadIsWithinClosingAccountDate() {
    // todo 待完善
    // var office: Office = Session.getInstance().currentOffice
    // ClosingAccount.isContainClosedCharge(job.jobNo, office ? office.officeId : 0, new mx.rpc.Responder(queryClosingDateResultHandler, view.faultHandler))
  }
  queryClosingDateResultHandler(result) {
    // if (result == null) return
    // isWithinCloseAccountDate = result.result as Boolean
  }
  /**
 * 根据整拼类型自动获取对应的自定义业务类型，如果有多个默认选中第一个
 */
  selectDefaultCutomJobType() {
    let options = this.view.$refs.customJobType.options
    options = options.filter(p => p.type === this.job.lob && p.containerLoadType === this.job.containerLoadType)
    if (options.length > 0) {
      this.job.customJobType = options[0].code
    }
    // CargoCARGO-46769 新增主票，不应该有形式分单页签
    if (this.job.containerLoadType !== ContainerLoadType.BC_CARGO_TYPE_FCL.code) {
      this.job.virtualHBL = false
    }
  }
  /**
 * 修改主票时更新小票HBL中的目的港代理和MBL的收货人信息
 */
  async refreshLclAgentPartyAndConsigneeLine(overseaAgentDetail) {
    if (overseaAgentDetail) {
      for (const slave of this.job.lclSlaves) {
        const model = new SeaExportJob(slave)
        const hdoc = await model.getCargoDocByType('HBL', false)
        const mdoc = await model.getCargoDocByType('MBL', false)
        if (!this.view.isJyd && hdoc && slave.cargoSource === 'SC') {
          hdoc.agentPartyLine1 = overseaAgentDetail.blAddress
          hdoc.agentPartyLine2 = overseaAgentDetail.blAddressLine2
          hdoc.agentPartyLine3 = overseaAgentDetail.blAddressLine3
          hdoc.agentPartyLine4 = overseaAgentDetail.blAddressLine4
          hdoc.agentPartyLine5 = overseaAgentDetail.blAddressLine5
          hdoc.agentPartyLine6 = overseaAgentDetail.blAddressLine6
          hdoc.agentPartyLine7 = overseaAgentDetail.blAddressLine7
          this.addCargoDocToModifiedSet(hdoc)
        }
        if (mdoc) {
          mdoc.consigneeCode = ''
          mdoc.consigneeLine1 = overseaAgentDetail.blAddress
          mdoc.consigneeLine2 = overseaAgentDetail.blAddressLine2
          mdoc.consigneeLine3 = overseaAgentDetail.blAddressLine3
          mdoc.consigneeLine4 = overseaAgentDetail.blAddressLine4
          mdoc.consigneeLine5 = overseaAgentDetail.blAddressLine5
          mdoc.consigneeLine6 = overseaAgentDetail.blAddressLine6
          this.addCargoDocToModifiedSet(mdoc)
        }
      }
    }
  }

  /**
   * 修改货物信息
   */
  async cargoCodeChange(data) {
    const job = this.job
    job.cargoCode = data
    if (data === null || data === '') {
      job.cargoCode = data
      job.cargoName = data
      this.view.form.cargoCode = ''
      this.view.form.cargoName = ''
    } else {
      const cargoInformation = getObjectByCache(basicCacheKeys.basic_data_CargoInformation, 'code', data)
      if (cargoInformation) {
        job.cargoCode = cargoInformation.code
        job.cargoName = cargoInformation.englishName
        this.view.form.cargoCode = cargoInformation.code
        this.view.form.cargoName = cargoInformation.englishName
      }
    }
  }

  /**
 * 选择开航日期更新分单签单日期，订舱航期
 */
  async ETDChangeEvent(value) {
    const job = this.job
    const oldValue = job.etd
    job.etd = value
    // CARGO-23752 【海运订舱极速版】-HBL 签发日期需要由【基本页签】实际开航日期(ATD)自动带出 主票下的小票数据在后端处理
    const cargoDocList = await new SeaExportJob(job).getSeaCargoDoc()
    if (cargoDocList && cargoDocList.length > 0 && parseInt(this.config.get('syncSignDateBl')) === 0) {
      for (const d of cargoDocList) {
        const allow = d.docType && (d.docType === 'MBL' || d.docType === 'MBL2') && d.state < 2 && (!d.signDateBL || (oldValue && dateCompare(d.signDateBL, oldValue) === 0))
        if (allow) {
          d.signDateBL = value
        }
      }
    }
    if (value) {
      let day = Number(this.config.get('SESignDateHBLRange'))
      if (isNaN(day) || day <= 0) {
        day = 3
      }
      day += 1
      // 截单日期默认天数
      const fileCutoffDay = Number(this.config.get('SEFileCutoffDetaultDay'))
      if (fileCutoffDay > 0) {
        const date = DateUtils.getFourDaysAgoWithoutHoliday(value, fileCutoffDay)
        const fileCutoff = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12)
        job.fileCutoff = DateUtils.formatStandardDateTime(fileCutoff)
      }
    }
  }
  /**
 * copy for MBL
 */
  async cargoDocChangeHandler() {
    const job = new SeaExportJob(this.job)
    const mbl = await job.getCargoDocByType('MBL', false)
    if (mbl && mbl.state > 0) {
      SeaCargoDoc.copyInfoFromJobPort(job, mbl).then(r => {})
    }
  }
  /**
 * 卸货港选择
 */
  async dischargingPortCodeChange(data, carrierId) {
    const job = this.job
    if (this.sEUseDischargingPort5Code && data.value) {
      this.refreshPortCode(data.value, carrierId)
    }
    job.overseaAgentPort = null
    job.dischargingPortCode = data.value
    const oldDestinationPortCode = job.destinationPortCode
    if (Number(this.config.get('SyncPOD')) === 1) {
      job.destinationPortCode = job.dischargingPortCode
    } else {
      job.destinationPortCode = job.destinationPortCode || job.dischargingPortCode
    }
    let port = null
    if (job.destinationPortCode) {
      const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
      port = seaPorts.find(p => p.code === job.destinationPortCode)
    }
    job.placeOfDeliveryRegion = port ? port.region : ''
    if (port && oldDestinationPortCode !== job.destinationPortCode && parseInt(this.config.get('FinalDestinationChange')) === 1) {
      this.job.destinationPlace = port.englishName
    }
    this.portChange()
    // 主票卸货港改变，小票的提单卸货港也要改变
    await new SeaExportJob(job).getLclSlaves()
    if (job.lclSlaves && job.lclSlaves.length > 0) {
      const seaPorts = this.seaPortList
      const ports = seaPorts.filter(p => p.code === job.loadingPortCode)
      if (ports.length > 0) {
        const destinationPort = ports[0]
        for (const item of job.lclSlaves) {
          const slave = new SeaExportJob(item)
          const hdoc = await slave.getCargoDocByType('HBL', true)
          const mdoc = await slave.getCargoDocByType('MBL', true)
          if (hdoc) {
            hdoc.dischargingPort = destinationPort.englishName
            this.addCargoDocToModifiedSet(hdoc)
          }
          if (mdoc) {
            mdoc.dischargingPort = destinationPort.englishName
            this.addCargoDocToModifiedSet(mdoc)
          }
        }
      }
    }
    // this.loadUserPort(job.dischargingPortCode)
    JobUtils.matchUserPortConfig(this.view, job)
    JobUtils.matchRegionWarehouseMappingConfig(job, warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData)
    JobUtils.loadingShipDate(job)
    await this.loadWarehouseRegion(true)
    this.updateSecondVesselInfo()
    this.setPlannerChange()
  }
  // 修改卸货港，查询卸货港维护的操作人员
  loadUserPort(code) {
    if (!code || !this.useUserPort) {
      return
    }
    getUserPortByCode({ code }).then(res => {
      if (res.data.length > 0) {
        const options = this.view.$refs.op.options
        for (const item of res.data) {
          const option = options.find(p => p.userId === item.userId)
          if (option) {
            this.job.op = option.userId
            new User(option).getDefaultDepartment('role', 'op', this.job.opOffice).then(dep => {
              this.job.opDepartment = dep ? dep.departmentId : 0
            })
          }
        }
      }
    })
  }
  /**
 * 目的地选择
 */
  destinationPortCodeChange(data) {
    const job = this.job
    job.destinationPortCode = data.value
    this.portChange().then(r => {})
    const seaPorts = this.seaPortList
    const ports = seaPorts.filter(p => p.code === job.destinationPortCode)
    if (ports.length > 0) {
      job.placeOfDeliveryRegion = ports[0].region
      // 开启配置项后交货地变更不会带到最终目的地1开启 0关闭(默认)
      if (parseInt(this.config.get('FinalDestinationChange')) === 1) {
        const destinationPort = ports[0]
        job.destinationPlace = destinationPort.englishName
      }
    }
    this.loadCustomerPortDestinationAgents().then(r => {})
  }
  /**
 * 订舱代理选择
 */
  bookingAgentChange(data) {
    this.job.bookingAgent = data.value
    this.carrierAgentSyncLoading(data)
    this.view.context.reloadCharge = true
    this.bookingAgentChangeCl().then(r => {})
  }
  /**
 * 是否同步船代
 */
  carrierAgentSyncLoading(company) {
    const job = this.job
    if (job.bookingAgent) {
      if (company && company.seaCmpAgent) {
        job.carrierAgentId = job.bookingAgent
      }
    }
  }
  /**
 * 修改船公司
 */
  async carrierChangeHandler(data, scacList, carrierScacEdit) {
    const job = this.job
    await JobUtils.changeCarrierId(this.view, job, data.value)
    if (!job.masterFlag && this.sEUseDischargingPort5Code) {
      this.refreshPortCode(job.dischargingPortCode, job.carrierId)
    }
    await this.refreshBookingAgentAutoComplete()
    JobUtils.matchUserPortConfig(this.view, this.job)
    JobUtils.matchRegionWarehouseMappingConfig(this.job, warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData)
    await JobUtils.loadingShipDate(this.view.form)
    // 根据船公司带出对应的scac
    this.job.carrierScac = await JobUtils.getCarrierScac(this.job.carrierId, scacList, carrierScacEdit)
  }
  /**
 * 船公司要与订舱代理进行关联
 */
  async refreshBookingAgentAutoComplete() {
    if (!this.isJoinCarrierBookingAgent || this.job.containerLoadType === 'BB') {
      return
    }
    const company = this.context.companyList.find(p => p.cmpIdx === this.job.carrierId)
    if (company) {
      company.bookingAgentList = ''
      const bookingAgentList = await new Company(company).getBookingAgentList(true, false)
      const keys = Array.from(bookingAgentList, p => p.bookingAgentUuid)
      this.view.bookingAgentList = this.companyList.filter(p => keys.includes(p.uuid))
    }
    this.job.bookingAgent = 0
  }
  /**
 * 揽货类型选择
 */
  async cargoSourceChange() {
    const job = this.job
    this.loadDestinationAgentDetaiHandler()
    const options = this.seaPortList
    let company = await Company.getCompanyById(job.destinationAgent)
    if (company) {
      company = new Company(company)
      const overseaAgentDetail = await company.getOverseaAgentDetail()
      this.refreshLclAgentPartyAndConsigneeLine(overseaAgentDetail, job.cargoSource)
    }
    if (job.cargoSource === 'NC') { // 如果是指定货
      const cmp = options.filter(p => p.cmpIdx === job.designationAgent)[0]
      this.loadOverseaAgentUserByLob(cmp)// 根据指定货确定海外客服
      this.checkNewJobCreditInfo()
      this.job.incoTerm = ColumnUtils.getIncoTermIsFobOrCif('FOB')
    } else {
      this.loadOverseaAgentUserByLob(company)// 还是根据目的港代理确定海外客服
      this.job.incoTerm = ColumnUtils.getIncoTermIsFobOrCif('CIF')
    }
    this.loadCompanyUserByCargoSource()
    JobUtils.matchUserPortConfig(this.view, this.job)
  }
  /**
   * 校验新增业务的信控
   * @param job
   * @returns {Promise<void>}
   */
  async checkNewJobCreditInfo() {
    const job = this.job
    if (StrUtils.isEmpty(job.uuid)) {
      // 新增业务时，需要判断是否可以新增该业务 CARGO-9472 超信控的合作伙伴不能新增业务
      const checkResult = this.checkNewJobCreditInfoFunc(job)
      this.view.processingPromiseList.push(checkResult)
      try {
        await checkResult
      } finally {
        const index = this.view.processingPromiseList.indexOf(checkResult)
        if (index > -1) {
          this.view.processingPromiseList.splice(index, 1)
        }
      }
    }
  }
  /**
   * 校验新增业务的信控
   * @param job
   * @returns {Promise<void>}
   */
  async checkNewJobCreditInfoFunc(job) {
    const params = JobUtils.getCreditCheckJob(job)
    await canCreateByCreditInfoDetail(params).then(async res => {
      if (res.data > 0) {
        const msg = {
          dangerouslyUseHTMLString: true,
          message: await JobUtils.checkDateAndAmountExceeded(res.data),
          type: 'warning',
          duration: 5000
        }
        this.view.$message.warning(msg)
        job.designationAgent = 0
      }
    })
  }
  /**
 * 加载海外客服信息
 */
  async loadOverseaOpChanged() {
    const job = this.job
    if (Number(job.overseaOp) > 0) {
      const user = this.userList.filter(p => p.userId === Number(job.overseaOp))[0]
      await this.overseaOpChangeHandler({ ...user, value: job.overseaOp })
    }
  }
  /**
 * 加载海外客服
 */
  async loadOverseaAgentChanged() {
    if (this.view.isHC) {
      return
    }
    const job = this.job
    if (Number(job.destinationAgent) > 0) {
      const company = await Company.getCompanyById(Number(job.destinationAgent))
      if (company) {
        await this.loadDestinationAgentDetai2Handler(company)
      } else {
        job.overseaOp = 0
        job.overseaOpDepartment = 0
      }
    }
  }
  async loadDestinationAgentDetai2Handler(company) {
    if (company) {
      company = new Company(company)
      const agent = await company.getOverseaAgentDetail()
      if (agent) {
        this.loadOverseaAgentUser2Handler(agent)
      }
    }
  }
  async loadOverseaAgentUser2Handler(overseaAgent) {
    if (this.view.isHC) {
      return
    }
    overseaAgent = new OverseaAgent(overseaAgent)
    const job = this.job
    const overseaAgentUsers = await overseaAgent.getOverseaAgentUserList()
    // 海外客服
    const overseaAgentUsersList = []
    if (overseaAgentUsers && overseaAgentUsers.length > 0) {
      for (var u of overseaAgentUsers) {
        if (u.lob === job.lob || !u.lob || u.lob === 'ALL') {
          const user = this.userList.filter(p => p.userId === u.userId)[0]
          if (user) {
            if (u.roleType === 5) { // 海外客服
              overseaAgentUsersList.push(user)
            }
          }
        }
      }
    }
    // 海外客服
    this.view.overseaOpList = overseaAgentUsersList
  }
  /**
 * 按业务指定海外客服
 */
  loadOverseaAgentUserByLob(company) {
    if (this.view.isHC) {
      return
    }
    const job = this.job
    if (company) {
      this.loadDestinationAgentDetaiHandler(company)
    } else {
      job.overseaOp = 0
      job.overseaOpDepartment = 0
      this.view.overseaOpList = []
    }
  }
  async loadDestinationAgentDetaiHandler(company) {
    if (company) {
      company = new Company(company)
      const agent = await company.getOverseaAgentDetail()
      if (agent) {
        this.loadOverseaAgentUserHandler(agent)
      }
    }
  }
  async loadOverseaAgentUserHandler(overseaAgent) {
    if (this.view.isHC) {
      return
    }
    const job = this.job
    // 海外客服
    const overseaAgentUsersList = []
    if (overseaAgent) {
      overseaAgent = new OverseaAgent(overseaAgent)
      const overseaAgentUsers = await overseaAgent.getOverseaAgentUserList()
      if (overseaAgentUsers && overseaAgentUsers.length > 0) {
        for (var u of overseaAgentUsers) {
          if (u.lob === job.lob || !u.lob || u.lob === 'ALL') {
            const user = this.userList.filter(p => p.userId === u.userId)[0]
            if (user) {
              if (u.roleType === 5) { // 海外客服
                overseaAgentUsersList.push(user)
              }
            }
          }
        }
      }
    }
    // 海外客服
    this.view.overseaOpList = overseaAgentUsersList
    if (overseaAgentUsersList.length > 0) {
      const user = overseaAgentUsersList[0]
      job.overseaOp = user.userId
      this.overseaOpChangeHandler({ ...user, value: user.userId })
    } else {
      job.overseaOp = 0
      job.overseaOpDepartment = 0
    }
  }
  /**
 * 目的港代理选择
 */
  async txtDestinationAgentChangeHandler(data) {
    this.view.showDestinationAgentWarning = false
    this.checkCreditByCompany(data.value, 'destinationAgent')
    const job = this.job
    const company = new Company(data)
    const overseaAgent = await company.getOverseaAgentDetail()
    this.refreshLclAgentPartyAndConsigneeLine(overseaAgent, job.cargoSource)
    job.destinationAgent = data.value
    CargoDocUtil.checkOverseaAgentProperties(job)
    if (job.cargoSource === 'SC') { // 如果是自揽货, 则更新海外客服
      this.loadOverseaAgentUserByLob(data)
    }
    if (this.view.isJyd) {
      for (const slave of job.lclSlaves) {
        if (slave.jobState === 0) {
          slave.destinationAgent = data.value
          this.addLclSlaveToModifiedSet(slave)
        }
      }
    }
    JobUtils.matchUserPortConfig(this.view, job)
  }
  txtDesignationAgentChangeHandler(data) {
    this.view.showDesignationAgentWarning = false
    this.checkCreditByCompany(data.value, 'designationAgent')
    const job = this.job
    job.designationAgent = data.value
    if (job.cargoSource === 'NC') { // 如果是指定货, 则更新海外客服
      this.loadOverseaAgentUserByLob(data)
      this.checkNewJobCreditInfo()
    }
  }
  checkCredit() {
    this.view.showDestinationAgentWarning = false
    this.view.showDesignationAgentWarning = false
    if (this.view.creditOpen) {
      const job = this.job
      // 目的港代理
      if (job && job.destinationAgent > 0) {
        this.checkCreditByCompany(job.destinationAgent, 'destinationAgent')
      }
      // 指定货代理
      if (job && job.designationAgent > 0) {
        this.checkCreditByCompany(job.designationAgent, 'designationAgent')
      }
    }
  }
  /**
   * item代表不同的表单项
   */
  checkCreditByCompany(companyId, item) {
    const callback = credit => {
      let checkCredit = false
      if (credit) {
        let tip = ''
        if (credit.amountExceeded || credit.dateExceeded) {
          const config = this.getCreditEDISetting()
          if (config.booking) {
            if (credit.amountExceeded) { tip += this.view.$t('CargoMsg.Cargo_Limit') }
            if (credit.dateExceeded) { tip += this.view.$t('CargoMsg.Cargo_AccountPeriod') }
            if (tip !== '') {
              const toolTip = this.view.$t('CargoMsg.Cargo_Parter') + tip + this.view.$t('SeaExport.HasExceeded')
              if (item === 'destinationAgent') {
                this.view.showDestinationAgentWarning = true
                this.view.destinationAgentTip = toolTip
              } else if (item === 'designationAgent') {
                this.view.showDesignationAgentWarning = true
                this.view.designationAgentTip = toolTip
              }
              checkCredit = true
            }
          }
        }
      }
      if (!credit || !checkCredit) {
        const company = this.context.companyList.find(p => p.cmpIdx === companyId)
        if (company && company.ifOpenSop && this.sopConfigOpen) {
          // if (type === 1 && view.imageB) {
          //   if (view.imageB) {
          //     view.imageB.visible = true
          //   }
          // } else if (type === 2) {
          //   if (view.imageA) {
          //     view.imageA.visible = true
          //   }
          // } else if (type === 3) {
          //   if (view.imageC) {
          //     view.imageC.visible = true
          //   }
          // }
        }
      }
    }
    CreditInfo.checkCreditInfo(companyId, CreditInfoUtil.getJobData(this.job)).then(res => {
      for (const item of res.data) {
        callback(item)
      }
    })
  }
  getCreditEDISetting() {
    const setting = this.config.get('creditBlockEDI')
    const a = setting.split(',')
    const r = {}
    for (const o of a) {
      let lock = false
      if (o.split('-')[1] === '1') {
        lock = true
      }
      r[o.split('-')[0]] = lock
    }
    return r
  }
  /**
 * 报关行
 */
  async customsBrokerChangeHandler(data) {
    const job = new SeaExportJob(this.job)
    // 这个验证必须在 job.customsBroker = data.value 赋值之前，否则此验证无意义
    SEUtils.refreshChargeAccountId(job, 'customsBroker', this.view.$t('SeaExport.CustomsBroker'), this.view.context.modifiedData) // 这里返回true 说明修改了费用结算对象以及开票抬头，需要将费用参与保存
    await job.getLclSlaves()
    for (const slave of job.lclSlaves) {
      if (slave.customsBroker === job.customsBroker) {
        slave.customsBroker = data.value
        this.addLclSlaveToModifiedSet(slave)
      }
    }
    job.customsBroker = data.value
    this.view.context.reloadCharge = true
  }
  /**
 * 运输公司
 */
  async carryingCmpChangeHandler(data) {
    const job = this.job
    // 这个验证必须在 job.carryingCmp = data.value 赋值之前，否则此验证无意义
    SEUtils.refreshChargeAccountId(job, 'carryingCmp', this.view.$t('SeaExport.HaulageCompany'), this.view.context.modifiedData) // 这里返回true 说明修改了费用结算对象以及开票抬头，需要将费用参与保存
    job.carryingCmp = data.value
    this.view.context.reloadCharge = true
    if (job.trucking.length === 0) {
      const newData = new TruckingInfo().fillDefaultValue().getData()
      newData.loadingPortService = true
      newData.jobUuid = job.uuid
      job.trucking.push(newData)
    }
    const truckingInfo = job.trucking[0]
    truckingInfo.carryingCmp = job.carryingCmp
    if (job.carryingCmp === 0) {
      truckingInfo.driver = ''
      truckingInfo.driverTel = ''
    }
    if (String(cache.config.get('ToExoSystem')) === 'XYCW' && this.job.etd) {
      if (truckingInfo.carryingCmp) {
        truckingInfo.loadingDate = DateUtils.addDays2(this.job.etd, -3)
      } else {
        truckingInfo.loadingDate = ''
      }
    }
    this.addTruckingToModifiedSet(truckingInfo)
    await JobUtils.getDriverInformationByCarryingCap(truckingInfo, truckingInfo.carryingCmp)
  }
  // 添加truckingInfo到被修改的集合中
  addTruckingToModifiedSet(truckingInfo) {
    const modifiedData = this.context.modifiedData
    modifiedData.truckingInfo = modifiedData.truckingInfo || []
    if (!modifiedData.truckingInfo.includes(truckingInfo)) {
      modifiedData.truckingInfo.push(truckingInfo)
    }
  }
  // 将truckingInfo从被修改的集合中移除
  removeTruckingFromModifiedSet(truckingInfo) {
    const modifiedData = this.context.modifiedData
    if (modifiedData.truckingInfo && modifiedData.truckingInfo.includes(truckingInfo)) {
      const index = modifiedData.truckingInfo.indexOf(truckingInfo)
      if (index > -1) {
        modifiedData.truckingInfo.splice(index, 1)
      }
    }
  }
  /**
   * 仓库
   */
  async warehouseCmpChangeHandler(data) {
    const job = this.job
    job.warehouseCmp = data.value || 0
    job.warehouseRecord = job.warehouseCmp
    if (job.warehouseInfo.length === 0) {
      const newData = new WarehouseInfo().fillDefaultValue().getData()
      newData.jobUuid = job.uuid
      job.warehouseInfo.push(newData)
    }
    this.view.warehouseNameList = []
    if (job.warehouseCmp > 0) {
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', job.warehouseCmp)
      if (companyCache) {
        getWarehouseDetail(companyCache.uuid).then(res => {
          if (res.data.length > 0) {
            this.view.warehouseNameList = res.data
          }
        })
      }
    }
    // 通过此方法加载 warehouseInfo 的联系电话地址等
    await this.getWarehouseInfo()
    const warehouse = job.warehouseInfo[0]
    warehouse.warehouseCmp = job.warehouseCmp
    job.warehouseName = warehouse.warehouseName
    this.addWarehouseToModifiedSet(warehouse)
  }
  // 添加warehouseInfo到被修改的集合中
  addWarehouseToModifiedSet(warehouse) {
    const modifiedData = this.context.modifiedData
    modifiedData.warehouseInfo = modifiedData.warehouseInfo || []
    if (!modifiedData.warehouseInfo.includes(warehouse)) {
      modifiedData.warehouseInfo.push(warehouse)
    }
  }
  // 将warehouseInfo从被修改的集合中移除
  removeWarehouseFromModifiedSet(warehouse) {
    const modifiedData = this.context.modifiedData
    if (modifiedData.warehouseInfo && modifiedData.warehouseInfo.includes(warehouse)) {
      const index = modifiedData.warehouseInfo.indexOf(warehouse)
      if (index > -1) {
        modifiedData.warehouseInfo.splice(index, 1)
      }
    }
  }
  /**
 * 箱型箱量修改
 */
  dgSeaEqItemEditEndHandler() {
    // ContainerUtil.autoAdjustMasterContainer(this.job)
  }
  /**
 * 包装选择
 */
  async txtPackingChangeHandler() {
    const job = new SeaExportJob(this.job)
    const mbl = await job.getCargoDocByType('MBL', false)
    if (mbl) {
      let count = 0
      // 其他地方通过billOfLadingSynMode控制
      // if (job.packing) {
      //   const packing = this.context.packingList.find(p => p.code === job.packing)
      //   const packingName = packing ? packing.name : ''
      //   mbl.packingName = packingName // 包装显示名
      //   count++
      // }
      const quantityContract = Number(job.quantityContract)
      if (quantityContract > 0) {
        mbl.quantitySum = this.getQuantitySum(quantityContract, job.packing)
        count++
      }
      if (count > 0) {
        this.addCargoDocToModifiedSet(mbl)
      }
    }
  }
  getQuantitySum(quantity, packingCode) {
    const options = this.context.packingList.filter(p => p.code === packingCode)
    if (options.length === 0) {
      return
    }
    let packing = options[0].name
    switch (packing) {
      case 'CTNS':
        packing = 'CARTONS'
        break
      case 'BALE':
        if (quantity !== 1) {
          packing = 'BALES'
        }
        break
      case 'PCS':
        packing = 'PIECES'
        break
    }
    return 'SAY ' + quantity + packing + ' ONLY.'
  }
  /**
 * 合并小票唛头、品名
 */
  mergeLclCargoDocInfo(filed, form) {
    const job = this.job
    const markList = []
    let mark = ''
    for (const item of job.lclSlaves) {
      const data = item[filed]
      if (data) {
        if (!markList.includes(data)) {
          markList.push(item[filed])
          mark += item[filed] + '\n'
        }
      }
    }
    if (mark) {
      const fData = form[filed]
      if (!fData || markList.includes(fData)) {
        form[filed] = mark
      } else {
        form[filed] += '\n' + mark
      }
    }
  }
  /**
 * 当选择销售人员的时候自动关联该销售所在分公司
 * */
  async txtSalesChangeHandler(data) {
    const job = this.job
    job.sales = data.value
    job.salesRecord = job.sales
    job.salesOffice = 0
    this.view.txtSalesOffice = ''
    job.salesDepartment = 0
    if (data.value) {
      if (data.defaultOfficeId) { // 用户设置了默认公司和部门就用默认的
        job.salesOffice = data.defaultOfficeId
        job.salesDepartment = data.defaultDepId
        const office = await Office.getOfficeById(job.salesOffice)
        this.view.txtSalesOffice = this.view.isZh ? office.chineseName : office.englishName
      } else {
        const offices = await User.getUserDepartmentOffices('role', 'sales', data.value)
        if (offices.length > 1) {
          for (const item of offices) {
            if (this.view.branchOfficeCheck || (!this.view.branchOfficeCheck && item.officeId === this.context.office.officeId)) {
              job.salesOffice = item.officeId
              job.salesDepartment = item.departmentId
              this.loadCompanyOffice()
              break
            }
          }
        } else {
          const user = new User(data)
          const department = await user.getDefaultDepartment('role', 'sales')
          job.salesDepartment = department ? department.departmentId : 0
          const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
          if (office) {
            job.salesOffice = office.officeId
            this.view.txtSalesOffice = this.view.isZh ? office.chineseName : office.englishName
          }
        }
      }
    }
    this.dipatchChangedSalesEvent(data.userId || 0)
  }
  /**
 * 销售部门修改后，调整分公司信息
 */
  departmentChargeHandler(data) {
    // const job = this.job
    // const office = Office.getOfficeByUuid(data.officeUuid)
    // job.salesDepartment = data.value
    // job.salesOffice = office ? office.officeId : 0
    // this.view.txtSalesOffice = office ? office.chineseName : ''
  }
  /**
 * 操作改变
 */
  async txtOPChangeHandler(data) {
    const job = this.job
    const user = new User(data)
    job.op = data.value
    if (user.defaultDepId > 0) {
      job.opDepartment = user.defaultDepId
    } else {
      const department = await user.getDefaultDepartment('role', 'op', job.opOffice)
      job.opDepartment = department ? department.departmentId : 0
    }
  }
  /**
 * 客服改变
 */
  async csrChangeHandler(data) {
    const job = this.job
    job.csr = data.value || 0
    job.csrDepartment = 0
    job.csrOffice = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'csr', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.csrOffice = office ? office.officeId : 0
            job.csrDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const department = await user.getDefaultDepartment('role', 'csr')
        job.csrDepartment = department ? department.departmentId : 0
        const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
        job.csrOffice = office ? office.officeId : 0
      }
    }
  }
  /**
 * 海外客服改变
 */
  async overseaOpChangeHandler(data) {
    const job = this.job
    job.overseaOp = data.value || 0
    const user = new User(data)
    job.overseaOpDepartment = 0
    if (job.overseaOp) {
      const offices = await User.getUserDepartmentOffices('role', 'overseaOp', job.overseaOp)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            this.job.overseaOpDepartment = item.departmentId
            break
          }
        }
      } else {
        const dep = await user.getDefaultDepartment('role', 'overseaOp')
        this.job.overseaOpDepartment = dep ? dep.departmentId : 0
      }
    }
    await new SeaExportJob(job).getLclSlaves()
    // CARGO-33102  海运出口-自拼箱主票海外客服同步小票模式调整 自揽货才进行同步
    if (job.overseaOp > 0 && job.lclSlaves && job.lclSlaves.length > 0) {
      const syncOverseaOp = String(this.config.get('SyncOverSeaOpByContainerLoadType'))
      const value1 = syncOverseaOp.indexOf('1') >= 0
      const value2 = syncOverseaOp.indexOf('2') >= 0
      for (const slave of job.lclSlaves) {
        if (slave.cargoSource === 'SC' && ((value1 && job.containerLoadType === ContainerLoadType.BC_CARGO_TYPE.code) || (value2 && job.containerLoadType === ContainerLoadType.LCL_CARGO_TYPE.code))) {
          slave.overseaOp = job.overseaOp
          slave.overseaOpDepartment = job.overseaOpDepartment
        }
      }
    }
  }
  async dcChangeHandler(data) {
    const job = this.job
    job.dc = data.value || 0
    job.dcDepartment = 0
    if (job.dc) {
      const offices = await User.getUserDepartmentOffices('role', 'doc', job.dc)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.dcOffice = office ? office.officeId : 0
            job.dcDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const department = await user.getDefaultDepartment('role', 'doc')
        job.dcDepartment = department ? department.departmentId : 0
        const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
        job.dcOffice = office ? office.officeId : 0
      }
    }
  }
  /**
 * 航线改变
 */
  async txtPlannerChangeHandler(data) {
    const job = this.job
    job.planner = data.value || 0
    job.plannerDepartment = 0
    job.plannerOffice = 0
    if (job.planner) {
      const offices = await User.getUserDepartmentOffices('role', 'seaLine', job.planner)
      if (offices && offices.length > 1) {
        // 多公司仅当命中当前分公司才回填；否则不臆测，由用户手动选航线部门（保存时 Rule 1 校验必填）
        const item = offices.find(o => o.officeId === this.context.office.officeId)
        if (item) {
          const office = await Office.getOfficeById(item.officeId)
          job.plannerOffice = office ? office.officeId : 0
          this.job.plannerDepartment = item.departmentId
        }
      } else {
        const user = await User.getUserById(job.planner)
        if (user) {
          const dep = await new User(user).getDefaultDepartment('role', 'seaLine')
          job.plannerDepartment = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.plannerOffice = office ? office.officeId : 0
        }
      }
    }
  }

  async prePortPlannerChangeHandler(data) {
    await JobUtils.prePortPlannerChangeHandler(data, this.job, this)
  }
  async lastMilePlannerChangeHandler(data) {
    await JobUtils.lastMilePlannerChangeHandler(data, this.job, this)
  }

  async loadCustomerPortDestinationAgents() {
    const job = this.job
    if (job.cargoSource === 'NC') {
      const company = await Company.getCompanyById(job.customerId)
      if (company) {
        this.loadCustomerDetail1Handler(company)
      }
    }
  }
  async loadCustomerDetail1Handler(company) {
    company = new Company(company)
    const customerDetail = await Company.loadCustomer(company.uuid).then(list => list.length > 0 ? list[0] : null)
    if (customerDetail) {
      this.loadPortDestinationAgentsHandler(customerDetail)
    }
  }
  async loadPortDestinationAgentsHandler(customer) {
    const job = this.job
    if (customer) {
      customer = new Customer(customer)
      const portDestinationAgents = await customer.getPortDestinationAgents()
      for (const agent of portDestinationAgents) {
        if (job.dischargingPortCode === agent.destinationPort) {
          job.designationAgent = agent.destinationAgentId
          // 指定货带网管
          this.loadOverseaAgentDetailOwner(job.designationAgent)
          break
        }
      }
    }
  }
  /**
* 指定货 -> 加载网管
*/
  async loadOverseaAgentDetailOwner(cmpIdx) {
    const cmp = await Company.getCompanyById(cmpIdx)
    if (cmp) {
      const overseaAgentDetail = await new Company(cmp).getOverseaAgentDetail()
      await this.loadOverseaAgentDetailOwnerHandler(overseaAgentDetail)
    }
  }
  async loadOverseaAgentDetailOwnerHandler(overseaAgentDetail) {
    const job = this.job
    if (overseaAgentDetail) {
      if (overseaAgentDetail) {
        // 添加指定货代理等级
        const overseaAgentGrade = getOverseaAgentGradeByCode(overseaAgentDetail.grade)
        if (overseaAgentGrade) {
          job.agentLevel = overseaAgentGrade.chineseName
        }
        if (this.salesOfficeCheck) {
          const userList = this.view.$refs.sales.options
          job.sales = 0
          for (const obj of userList) {
            if (obj.userId === overseaAgentDetail.owner && obj.active) {
              job.sales = overseaAgentDetail.owner
            }
          }
        } else {
          job.sales = overseaAgentDetail.owner
        }
      }
    } else {
      job.sales = 0
    }
    this.salesChangeHandler()
  }
  /**
* 当选择销售人员的时候自动关联该销售所在分公司
* */
  async salesChangeHandler() {
    const job = this.job
    const user = this.userList.filter(p => p.userId === job.sales)[0]
    if (user) {
      if (user.defaultOfficeId) { // 用户设置了默认公司和部门就用默认的
        job.salesOffice = user.defaultOfficeId
        job.salesDepartment = user.defaultDepId
        this.loadCompanyOffice()
      } else {
        const officeList = await User.getUserDepartmentOffices('role', 'sales', user.userId)
        this.getUserDepartmentOfficesHandler(officeList)
      }
    } else {
      if (this.view.isEdit) {
        job.salesDepartment = 0
        job.salesOffice = 0
      }
    }
  }
  async getUserDepartmentOfficesHandler(officeList) {
    const job = this.job
    if (officeList != null && officeList.length > 1) {
      for (const item of officeList) {
        if (item.officeId === this.context.office.officeId) {
          job.salesDepartment = item.departmentId
          job.salesOffice = item.officeId
          this.loadCompanyOffice()
          break
        }
      }
    } else {
      let user = this.userList.filter(p => p.userId === job.sales)[0]
      if (user) {
        user = new User(user)
        const dep = await user.getDefaultDepartment('role', 'sales')
        this.getDefaultSalesResult2(dep)
      } else {
        this.getDefaultSalesResult2()
      }
    }
  }
  getDefaultSalesResult2(department) {
    const job = this.job
    if (department) {
      const office = this.context.officeList.filter(p => p.uuid === department.officeUuid)[0]
      job.salesDepartment = department.departmentId
      job.salesOffice = office ? office.officeId : 0
    } else {
      job.salesDepartment = 0
      job.salesOffice = 0
    }
    this.loadCompanyOffice()
  }
  async loadCompanyOffice() {
    const job = this.job
    const office = await Office.getOfficeById(job.salesOffice)
    if (office) {
      this.view.txtSalesOffice = this.view.isZh ? office.chineseName : office.englishName
    } else {
      this.view.txtSalesOffice = ''
    }
  }
  /**
* 创建小票
*/
  async selectWindowHandler(value) {
    this.job.chargeWeight = 0
    const lclJob = await new SeaExportJob(this.job).batchCloneLcLJob()
    new SeaExportJob(lclJob).fillDefaultValue() // 数据补充完整
    lclJob.lclMasterUuid = this.job.uuid
    lclJob.lclMaster = this.job
    lclJob.lclNumber = value
    const syncOverseaOp = String(this.config.get('SyncOverSeaOpByContainerLoadType'))
    const value1 = syncOverseaOp.indexOf('1') >= 0
    const value2 = syncOverseaOp.indexOf('2') >= 0
    // CARGO-33102  海运出口-自拼箱主票海外客服同步小票模式调整 自揽货才进行同步
    if (this.job.overseaOp > 0 && lclJob.cargoSource === 'SC') {
      if ((value1 && this.job.containerLoadType === ContainerLoadType.BC_CARGO_TYPE.code) || (value2 && this.job.containerLoadType === ContainerLoadType.LCL_CARGO_TYPE.code)) {
        lclJob.overseaOp = this.job.overseaOp
        lclJob.overseaOpDepartment = this.job.overseaOpDepartment
      } else {
        lclJob.overseaOp = 0
        lclJob.overseaOpDepartment = 0
      }
    }
    // CARGO-30705 主票下添加业务参考号栏位（非【BCF】整拼类型，创建小票时，不带入【业务参考号】）
    this.view.$emit('addLcl', lclJob, true)
  }
  async slavedAddedHandler(rows) {
    this.context.loading = true
    try {
      await batchAddJob(rows, this.job.uuid, this.job.mbl, this.view.location).then(res => {
        const result = res.data
        if (result && result.length > 0) {
          for (const selectSlave of rows) {
            for (const slave of result) {
              if (selectSlave.uuid === slave.uuid) {
                slave.soNo = selectSlave.soNo
                if (slave.fba) {
                  slave.fbaWarehouseCode = selectSlave.fbaWarehouseCode
                  slave.fbaPreAmazonWhTime = selectSlave.fbaPreAmazonWhTime
                }
              }
            }
          }
          for (const item of result) {
            new SeaExportJob(item).fillDefaultValue() // 数据补充完整
            const oldRow = this.view.rowData.find(p => p.uuid === item.uuid)
            if (oldRow) {
              Object.assign(oldRow, item)
            } else {
              this.view.rowData.push(item)
            }
          }
          this.view.gridApi.setRowData(this.view.rowData)
          this.view.$emit('addSlavedJob', res.data)
          this.refreshLclMaster(this.job)
          JobUtils.checkMasterShare(this.job.uuid)
        }
      })
      await this.updateJMT()
    } finally {
      this.context.loading = false
    }
    // if (job.needLoadForBooking2()) {
    // 	job.loadForBooking3(new Responder(loadForBooking2ResultHandler, view.faultHandler))
    // }
    // else {
    // 	loadForBooking2ResultHandler()
    // }
  }
  // 更新件毛体信息
  async updateJMT() {
    await getSeaExportJobByUuid(this.job.uuid).then((res) => {
      const result = res.data ? res.data : null
      if (result) {
        this.job.quantityActual = result.quantityActual
        this.job.weightActual = result.weightActual
        this.job.cubageActual = result.cubageActual
        this.job.quantityContract = result.quantityContract
        this.job.weightContract = result.weightContract
        this.job.cubageContract = result.cubageContract
        this.job.chargeWeight = result.chargeWeight
        this.job.version = result.version
      }
    })
  }
  loadForBooking2ResultHandler(evt = null) {
    // var slaves: IList = queryLclWindow.selectedSalves()
    // for each(var slave: SeaExportJob in slaves)
    // {
    // 	SEHierarchicalDataManager.getInstance().attach(slave, job, true)
    // }
    // ContainerUtil.refreshContainersJobs(job)
    // refreshLclMaster(job)
    // var refresh: CommonFormEvent = new CommonFormEvent("refreshJob")
    // view.dispatchEvent(refresh)
  }
  validateDelJobResultHandler(obj) {
    this.view.$logger.log('obj========', obj)
    if (obj.hasOwnProperty('status')) {
      this.view.$confirm(this.view.$t('Message.SureDelete'), this.view.$t('Message.Prompt'), {
        confirmButtonText: this.view.$t('common.btn.ok'),
        cancelButtonText: this.view.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        if (!this.view.selectedRow) return
        this.view.$logger.log('this.view.selectedRow========', this.view.selectedRow)
        this.removeSubJob = this.view.selectedRow
        let location = null
        if (!this.view.isFba) {
          location = 'seSeaBooking'
        }
        batchDeleteJob({ jobKeys: [this.removeSubJob.uuid], location: location }).then(res => {
          this.delJobResultHandler(res.data)
        })
      }).catch(() => { })
    } else {
      throw new ErrorTip(obj.msg)
    }
  }
  delJobResultHandler(num) {
    if (num > 0) {
      this.view.$message.success(this.view.$t('Message.DeleteSuccessfully'))
      const index = this.view.rowData.findIndex(p => this.removeSubJob && p.uuid === this.removeSubJob.uuid)
      if (index > -1) {
        this.view.rowData.splice(index, 1)
        this.view.gridApi.setRowData(this.view.rowData)
        this.view.selectedRowIndex = -1
        this.view.gridApi.clearFocusedCell()
      }
      this.view.$emit('removeJob', this.removeSubJob.uuid)
      this.refreshLclMaster(this.job)
    }
  }
  /**
* 批量移出小票
*/
  async btnRemoveBatchClickHandler() {
    const selectedItems = this.view.gridApi.getSelectedRows()
    if (selectedItems.length === 0) {
      throw new ErrorTip(this.view.$t('SeaExport.UncheckedSmallTicket'), 'info')
    }
    for (const subJob of selectedItems) {
      await new SeaExportJob(subJob).getContainerUsages()
      if (subJob.quantityActual !== this.getItemLeft(subJob) || subJob.weightActual !== this.getWeightLeft(subJob) ||
        subJob.cubageActual !== this.getCubageLeft(subJob)) {
        throw new ErrorTip(this.view.$t('Message.TheSubBillHasBeenConsolidatedAndCannotBeRemoved'))
      }
      for (const c of subJob.containerUsages) {
        if (c.container && c.container.jobUuid && c.container.jobUuid === this.job.uuid) {
          throw new ErrorTip(this.view.$t('Message.TheSubBillHasBeenConsolidatedAndCannotBeRemoved'))
        }
      }
      if (!await SecurityUtil.canOPEditWithAlert(subJob)) {
        return
      }
    }
    this.removedSubJobs = selectedItems
    const jobKeys = Array.from(selectedItems, p => p.uuid)
    await checkJobForShared(jobKeys).then(res => {
      if (res.data) {
        this.view.$message.warning(res.data + this.view.$t('CargoMsg.Cargo_SmallTicketCannotBeRemoved'))
      } else {
        this.doBatchRemoveJob(jobKeys, selectedItems)
      }
    })
  }
  doBatchRemoveJob(jobKeys, selectedItems) {
    batchRemoveJob(jobKeys, this.view.location).then(res => {
      this.onSaveBatchSucceeded(res.data)
      this.view.gridApi.updateRowData({ 'remove': selectedItems })
    })
  }
  onSaveBatchSucceeded(num) {
    if (num > 0) {
      this.job.lclSlaves = ''
      new SeaExportJob(this.job).getLclSlaves().then(data => {
        this.refreshLclMaster(this.job)
      })
      const jobKeys = Array.from(this.removedSubJobs, p => p.uuid)
      this.view.$emit('removeJobFromMaster', jobKeys)
      this.updateJMT()
    }
  }
  getItemLeft(input) {
    let quantity = input.quantityActual
    for (const usage of input.containerUsages) {
      quantity = quantity - usage.quantity
    }
    return quantity
  }
  getWeightLeft(input) {
    let weight = input.weightActual
    if (isNaN(weight)) {
      weight = 0.0
    }
    for (const usage of input.containerUsages) {
      let usedWeight = usage.weight
      if (isNaN(usedWeight)) {
        usedWeight = 0.0
      }
      weight = weight - usedWeight
    }
    return weight
  }
  getCubageLeft(input) {
    let cubage = input.cubageActual
    if (isNaN(cubage)) {
      cubage = 0.0
    }
    for (const usage of input.containerUsages) {
      let usedCubage = usage.cubage
      if (isNaN(usedCubage)) {
        usedCubage = 0.0
      }
      cubage = cubage - usedCubage
    }
    return cubage
  }
  async refreshLclMaster(seJob) {
    if (!seJob) {
      return
    }
    if (!this.view.isEdit) {
      this.job.seaCargoDoc = ''
      this.job.cargoDoc = ''
      return
    }
    const mbl = await new SeaExportJob(this.job).getMainMbl()
    if (mbl) {
      CargoDocUtil.changeJobSynToBillOfLading(seJob, mbl)
      mbl.quantitySum = this.getQuantitySum(mbl.quantity, mbl.packing)
    }
  }
  /**
* 箱型箱种 删除
*/
  deleteEQ() {
    // if (view.dgSeaEq.selectedItem == null) return
    // var seaEQ: SeaEQ = view.dgSeaEq.selectedItem as SeaEQ
    // //检查: 已输入箱型箱种信息不能删
    // if (!ContainerUtil.checkCanDelSeaEQ(seaEQ, job)) {
    // 	MessageDialog.info(resourceManager.getString('Message', 'ContainerSealInfoHasBeenEnteredCannotBeDeleted'))
    // 	return
    // }
    // seaEQ.job = null
    // if (job.seaEQ.contains(seaEQ)) {
    // 	job.seaEQ.removeItemAt(job.seaEQ.getItemIndex(seaEQ))
    // }
    // // 更新装箱信息中的箱型信息
    // ContainerUtil.autoAdjustMasterContainer(job)
  }
  /**
* 箱型箱种 新增
*/
  addEQ() {
    // if (job.seaEQ == null) {
    // 	job.seaEQ = new ArrayCollection()
    // }
    // var eqSize: Array = CacheManager.getInstance().getLocalCache(EQSize.CODE_NAME) as Array
    // var seaEQ: SeaEQ = new SeaEQ()
    // if (job.seaEQ && job.seaEQ.length == 0) {
    // 	seaEQ.EQsize = "20"
    // }
    // else {
    // 	for each(var size: EQSize in eqSize) {
    // 		var found: Boolean = false
    // 		for each(var eq: SeaEQ in job.seaEQ) {
    // 			if (size.code == eq.EQsize && eq.EQtype == "GP") {
    // 				found = true
    // 				break
    // 			}
    // 		}
    // 		if (!found) {
    // 			seaEQ.EQsize = size.code
    // 			break
    // 		}
    // 	}
    // }
    // seaEQ.job = job
    // seaEQ.EQtype = "GP"
    // seaEQ.EQquantity = 1
    // seaEQ.joinContainerId = UIDUtil.createUID()
    // if (!job.seaEQ.contains(seaEQ)) {
    // 	job.seaEQ.addItem(seaEQ)
    // }
    // ContainerUtil.autoAdjustMasterContainer(job)
    // view.dgSeaEq.dataProvider = job.seaEQ
    // view.dgSeaEq.validateNow()
  }
  /**
* 手动选择销售
*/
  dipatchChangedSalesEvent(sales) {
    // var salesEvent: CommonFormEvent = new CommonFormEvent("salesChanged")
    // salesEvent.data = sales
    // view.dispatchEvent(salesEvent)
  }
  async containerLoadTypeChange() {
    if (this.job.containerLoadType === ContainerLoadType.BC_CARGO_TYPE_FCL.code) {
      this.view.$emit('containerLoadTypeChange')
    }
    // 判断客户是否有维护默认的主单运输条款
    const shippingTermList = await getSpecificBasicData(basicCacheKeys.basic_data_ShippingTerm)
    if (shippingTermList && shippingTermList.length > 0) {
      for (const shippingTerm of shippingTermList) {
        let isFind = false
        const shippingTermOperationTypes = shippingTerm.shippingTermOperationTypes
        if (shippingTermOperationTypes && shippingTermOperationTypes.length > 0) {
          for (const item of shippingTermOperationTypes) {
            if (item.containerLoadType === this.job.containerLoadType && item.mbl && item.lob === 'SE') {
              isFind = true
              break
            }
          }
        }
        if (isFind) {
          this.job.freightTerm = shippingTerm.code
          break
        }
      }
    }
    JobUtils.matchUserPortConfig(this.view, this.job)
    JobUtils.matchRegionWarehouseMappingConfig(this.job, warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData)
    this.view.customJobTypeList = JobUtils.setCustomJobTypeList(this.job.lob, this.job.containerLoadType, this.job.fba)
  }
  // 加载仓库航线关联信息,并初始化仓库下拉框数据
  async loadWarehouseRegion(updateWarehousing = false) {
    const job = this.job
    const openAssociatedRoute = parseInt(this.config.get('AssociatedRoute')) === 1
    if (!job.dischargingPortCode || !openAssociatedRoute) return
    const port = this.seaPortList.find(p => p.code === job.dischargingPortCode)
    if (port) {
      const region = this.regionList.find(p => p.code === port.region)
      if (region && region.warehouseRegions && region.warehouseRegions.length > 0) {
        if (region.warehouseRegions.length === 1) {
          const warehouse = this.companyList.find(p => p.uuid === region.warehouseRegions[0].companyUuid)
          if (warehouse) {
            if (updateWarehousing && job.warehousing) {
              this.warehouseCmpChangeHandler({ value: warehouse.cmpIdx })
            }
          }
        } else {
          if (updateWarehousing && job.warehousing) {
            let defaultWarehouseCompany = null
            const warehouseCompanyList = []
            for (const warehouseRegion of region.warehouseRegions) {
              const warehouseCompany = this.companyList.find(p => p.uuid === warehouseRegion.companyUuid)
              if (warehouseCompany) {
                if (warehouseCompanyList.findIndex(p => p.uuid === warehouseCompany.uuid) < 0) {
                  warehouseCompanyList.push(warehouseCompany)
                }
              }
            }
            if (warehouseCompanyList && warehouseCompanyList.length > 0) {
              for (const warehouseCompany of warehouseCompanyList) {
                await new Company(warehouseCompany).getWarehouseDetail()
                const defaultWarehouse = Company.defaultWarehouse(warehouseCompany)
                if (defaultWarehouse) {
                  defaultWarehouseCompany = warehouseCompany
                  break
                }
              }
              if (!job.warehouseCmp || job.warehouseCmp === 0) {
                if (defaultWarehouseCompany) {
                  await this.warehouseCmpChangeHandler({ value: defaultWarehouseCompany.cmpIdx })
                } else {
                  await this.warehouseCmpChangeHandler({ value: 0 })
                }
              }
            }
          }
        }
      }
    }
  }
  // 前置仓
  async backUpWarehouseCmpChangeHandler(data) {
    const job = this.job
    job.backUpWarehouseCmp = data.value || 0
    job.backUpWarehouseRecord = job.backUpWarehouseCmp
    if (!job.backUpWarehouseInfo || job.backUpWarehouseInfo.length === 0) {
      const newData = new BackUpWarehouseInfo().fillDefaultValue().getData()
      newData.jobUuid = job.uuid
      job.backUpWarehouseInfo = []
      job.backUpWarehouseInfo.push(newData)
    }
    await this.getBackUpWarehouseInfo()
    const warehouse = job.backUpWarehouseInfo[0]
    warehouse.warehouseCmp = job.backUpWarehouseCmp
    if (warehouse.warehouseCmp && warehouse.warehouseCmp > 0) warehouse.deleted = false
    this.addBackUpWarehouseToModifiedSet(warehouse)
  }
  addBackUpWarehouseToModifiedSet(warehouse) {
    const modifiedData = this.context.modifiedData
    if (modifiedData) {
      modifiedData.backUpWarehouseInfo = modifiedData.backUpWarehouseInfo || []
      if (!modifiedData.backUpWarehouseInfo.includes(warehouse)) {
        modifiedData.backUpWarehouseInfo.push(warehouse)
      }
    }
  }
  // 前置仓修改事件
  backUpWarehouseChange() {
    const job = this.job
    if (!job.backUpWarehouse) {
      job.backUpWarehouseCmp = 0
      if (job.backUpWarehouseInfo && job.backUpWarehouseInfo.length > 0) {
        for (const item of job.backUpWarehouseInfo) {
          if (item.uuid) {
            item.jobUuid = ''
            item.deleted = true
            this.addBackUpWarehouseToModifiedSet(item)
          } else {
            this.removeBuckUpWarehouseFromModifiedSet(item)
          }
        }
      }
    }
  }
  // 将backUpWarehouseInfo从被修改的集合中移除
  removeBuckUpWarehouseFromModifiedSet(backUpWarehouseInfo) {
    const modifiedData = this.context.modifiedData
    if (modifiedData.backUpWarehouseInfo && modifiedData.backUpWarehouseInfo.includes(backUpWarehouseInfo)) {
      const index = modifiedData.backUpWarehouseInfo.indexOf(backUpWarehouseInfo)
      if (index > -1) {
        modifiedData.backUpWarehouseInfo.splice(index, 1)
      }
    }
  }
  //
  async loadBackUpWarehouseCompany() {
    this.view.backUpWarehouseCompanyList = []
    const companyList = []
    await getBackUpWarehouseCompany().then(res => {
      if (res.data && res.data.length > 0) {
        for (const company of res.data) {
          if (company.branchId === 1 || company.branchId === this.view.$store.getters.currentOfficeId) {
            companyList.push(company)
          }
        }
      }
    }).catch().finally()
    if (companyList.length > 0) {
      this.view.backUpWarehouseCompanyList = companyList
    }
  }
  /**
   * 加载job前置仓库信息
   */
  loadBackUpWarehouseCmp() {
    const job = this.job
    if (job.backUpWarehouseInfo != null && job.backUpWarehouseInfo.length > 0) {
      job.backUpWarehouseCmp = job.backUpWarehouseInfo[0].warehouseCmp
    } else {
      job.backUpWarehouseCmp = 0
    }
  }
  // 自定义岗位字段1
  async userDefinedRoleId1Handler(data) {
    const job = this.job
    job.userDefinedRoleId1 = data.value || 0
    job.userDefinedRoleDept1 = 0
    job.userDefinedRoleOffice1 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole1', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            this.job.userDefinedRoleDept1 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice1 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole1')
        job.userDefinedRoleDept1 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice1 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段2
  async userDefinedRoleId2Handler(data) {
    const job = this.job
    job.userDefinedRoleId2 = data.value || 0
    job.userDefinedRoleDept2 = 0
    job.userDefinedRoleOffice2 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole2', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            this.job.userDefinedRoleDept2 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice2 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole2')
        job.userDefinedRoleDept2 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice2 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段3
  async userDefinedRoleId3Handler(fieldData) {
    const value = fieldData.value
    // if (!$store.getters.enableFrontEndPlugin) {
    //   value = fieldData.value
    // }
    const job = this.job
    job.userDefinedRoleId3 = value || 0
    job.userDefinedRoleDept3 = 0
    job.userDefinedRoleOffice3 = 0
    if (value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole3', value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            job.userDefinedRoleDept3 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice3 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(fieldData) // !$store.getters.enableFrontEndPlugin ? new User(fieldData) : new User({ value })
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole3')
        job.userDefinedRoleDept3 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice3 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段4
  async userDefinedRoleId4Handler(fieldData) {
    const value = fieldData.value
    // if (!$store.getters.enableFrontEndPlugin) {
    //   value = fieldData.value
    // }
    const job = this.job
    job.userDefinedRoleId4 = value || 0
    job.userDefinedRoleDept4 = 0
    job.userDefinedRoleOffice4 = 0
    if (value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole4', value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            job.userDefinedRoleDept4 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice4 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(fieldData) // !$store.getters.enableFrontEndPlugin ? new User(fieldData) : new User({ value })
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole4')
        job.userDefinedRoleDept4 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice4 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段5
  async userDefinedRoleId5Handler(data) {
    const job = this.job
    job.userDefinedRoleId5 = data.value || 0
    job.userDefinedRoleDept5 = 0
    job.userDefinedRoleOffice5 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole5', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            this.job.userDefinedRoleDept5 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice5 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole5')
        job.userDefinedRoleDept5 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice5 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段6
  async userDefinedRoleId6Handler(data) {
    const job = this.job
    job.userDefinedRoleId6 = data.value || 0
    job.userDefinedRoleDept6 = 0
    job.userDefinedRoleOffice6 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole6', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            this.job.userDefinedRoleDept6 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice6 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole6')
        job.userDefinedRoleDept6 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice6 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段7
  async userDefinedRoleId7Handler(data) {
    const job = this.job
    job.userDefinedRoleId7 = data.value || 0
    job.userDefinedRoleDept7 = 0
    job.userDefinedRoleOffice7 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole7', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            this.job.userDefinedRoleDept7 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice7 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole7')
        job.userDefinedRoleDept7 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice7 = office ? office.officeId : 0
      }
    }
  }
  /**
   * 检查业务参考号是否存在
   */
  async customerRefNoFocusOutHandler(event) {
    const job = this.job
    if (!StrUtils.isEmpty(job.customerRefNo)) {
      job.customerRefNo = job.customerRefNo.trim()
      const checkJobFields = {}
      checkJobFields.customerRefNo = job.customerRefNo
      const fieldExistResult = await SeaExportJob.checkJobFieldExist(this.view.$store.getters.currentOfficeId, job.lob, checkJobFields, job.uuid)
      if (fieldExistResult.customerRefNo) {
        this.view.customerRefNoTip = this.view.$t('Message.BusinessReferenceNoReduplicated')
      } else {
        this.view.customerRefNoTip = ''
      }
    }
  }

  /**
   * 主单运费条款
   */
  async paymentTermMBLChange() {
    const job = new SeaExportJob(this.job)
    const mdoc = await job.getCargoDocByType('MBL', false)
    if (mdoc) {
      const loadingPort = this.seaPortList.filter(p => p.code === job.loadingPortCode)[0]
      const destinationPort = this.seaPortList.filter(p => p.code === job.destinationPortCode)[0]
      // 主单运费条款
      if (job.paymentTermMBL === 'PP' || job.paymentTermMBL === '3P') {
        // PP 主单付款地点-----起运港
        mdoc.paymentPlaceBL = !loadingPort ? '' : loadingPort.englishName
      } else if (job.paymentTermMBL === 'CC') {
        // CC 主单付款地点-----目的港
        mdoc.paymentPlaceBL = !destinationPort ? '' : destinationPort.englishName
      }
    }
  }
  // 修改二程信息
  updateSecondVesselInfo() {
    const job = this.job
    // 当勾选中转港的时候录入【中转港与卸货港值】才能同步到【海运二程信息中的起运港、目的港中】，如果没有勾选中转港那么就不需要同步。
    if (job.transfering && job.transferPortCode && job.dischargingPortCode) {
      const transferPort = getObjectByCache(basicCacheKeys.basic_data_Seaport, 'code', job.transferPortCode)
      if (transferPort) {
        job.secondPol = transferPort.englishName || ''
      }
      const dischargingPort = getObjectByCache(basicCacheKeys.basic_data_Seaport, 'code', job.dischargingPortCode)
      if (dischargingPort) {
        job.secondPod = dischargingPort.englishName || ''
      }
    }
  }
  async cargoSalesChargeHandler(data) {
    const job = this.job
    job.cargoSalesId = data.value || 0
    job.cargoSalesDepartment = 0
    job.cargoSalesOffice = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'salesOfGoods', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.cargoSalesOffice = office ? office.officeId : 0
            job.cargoSalesDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const department = await user.getDefaultDepartment('role', 'salesOfGoods')
        if (department) {
          job.cargoSalesDepartment = department ? department.departmentId : 0
          const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
          job.cargoSalesOffice = office ? office.officeId : 0
        }
      }
    }
  }
  // 设置航线负责人
  async setPlannerChange() {
    const job = this.job
    if (this.view.isEdit && !job.uuid && this.view.action === 'add') {
      const port = this.seaPortList.find(p => p.code === job.dischargingPortCode)
      if (port) {
        const region = this.regionList.find(p => p.code === port.region)
        if (region && region.plannerList) {
          const pList = region.plannerList.split(',')
          let p = 0
          for (const u of pList) {
            const t = u.split('-')
            if (t.length === 2 && (t[0] === 'SE' || t[0] === 'ALL')) {
              p = Number(t[1]) || 0
            } else {
              p = Number(t[0]) || 0
            }
            if (p) {
              break
            }
          }
          if (p > 0) {
            job.planner = p
          }
          if (job.planner) {
            await this.txtPlannerChangeHandler({ value: job.planner })
          }
        }
      }
    }
  }
  // 选择揽货类型带出合作伙伴对应的服务人员【单证】【客服】【自定义岗位1】【自定义岗位2】
  loadCompanyUserByCargoSource() {
    if (this.IsSpecifiedSalesBusiness) {
      const company = this.companyList.find(p => p.cmpIdx === this.job.customerId)
      if (company) {
        Company.getCompanyUsers(company.uuid).then(data => {
          const companyUsers = data.filter(p => (p.cargoSource === this.job.cargoSource || !p.cargoSource))
          this.loadCompanyUserByCargoSourceHandler(companyUsers)
        })
      }
    }
  }
  async loadCompanyUserByCargoSourceHandler(companyUsers) {
    const job = this.job
    // 客服
    const csrList = []
    // 对应揽货类型的客服
    const csrCargoSourceList = []
    let csrDefaultId = 0
    // 单证
    const dcList = []
    // 对应揽货类型的单证
    const dcCargoSourceList = []
    let dcDefaultId = 0
    // 操作
    const opList = []
    let opDefaultId = 0
    // 海外客服
    const overseaOpList = []
    let overseaOpDefaultId = 0
    // 自定义岗位1
    const userDefinedRoleId1List = []
    // 对应揽货类型的自定义岗位1
    const userDefinedRoleId1CargoSourceList = []
    let userDefinedRoleId1 = 0
    // 自定义岗位2
    const userDefinedRoleId2List = []
    // 对应揽货类型的自定义岗位2
    const userDefinedRoleId2CargoSourceList = []
    let userDefinedRoleId2 = 0
    if (companyUsers && companyUsers.length > 0) {
      for (const u of companyUsers) {
        if (u.lob === 'SE' || u.lob === 'ALL') {
          const user = this.userList.find(p => p.userId === u.userId)
          if (user && user.active) {
            if (u.roleType === CargoOfRoleType.CSR_TYPE.code) { // 客服
              if (u.defaultUser) {
                csrDefaultId = u.userId
              }
              if (u.cargoSource === job.cargoSource) {
                csrCargoSourceList.push(user)
              } else {
                csrList.push(user)
              }
            } else if (u.roleType === CargoOfRoleType.DOC_TYPE.code) { // 单证
              if (u.defaultUser) {
                dcDefaultId = u.userId
              }
              if (u.cargoSource === job.cargoSource) {
                dcCargoSourceList.push(user)
              } else {
                dcList.push(user)
              }
            } else if (u.roleType === CargoOfRoleType.OP_TYPE.code) { // 操作
              if (u.defaultUser) {
                opDefaultId = u.userId
              }
              opList.push(user)
            } else if (u.roleType === CargoOfRoleType.OVERSEAOP_TYPE.code) { // 海外客服
              if (u.defaultUser) {
                overseaOpDefaultId = u.userId
              }
              overseaOpList.push(user)
            } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE1.code) { // 自定义岗位1
              if (u.defaultUser) {
                userDefinedRoleId1 = u.userId
              }
              if (u.cargoSource === job.cargoSource) {
                userDefinedRoleId1CargoSourceList.push(user)
              } else {
                userDefinedRoleId1List.push(user)
              }
            } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE2.code) { // 自定义岗位2
              if (u.defaultUser) {
                userDefinedRoleId2 = u.userId
              }
              if (u.cargoSource === job.cargoSource) {
                userDefinedRoleId2CargoSourceList.push(user)
              } else {
                userDefinedRoleId2List.push(user)
              }
            }
          }
        }
      }
    }
    // 客服
    if (csrCargoSourceList.length > 0) {
      job.csr = csrCargoSourceList[0].userId
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.csr)
        this.csrChangeHandler({ ...user, value: user.userId })
      })
    } else if (csrList.length > 0) {
      if (csrDefaultId > 0) {
        job.csr = csrDefaultId
      } else {
        job.csr = csrList[0].userId
      }
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.csr)
        this.csrChangeHandler({ ...user, value: user.userId })
      })
    } else {
      // job.csr = 0
      // job.csrDepartment = 0
      // job.csrOffice = 0
    }
    // 单证
    if (dcCargoSourceList.length > 0) {
      job.dc = dcCargoSourceList[0].userId
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.dc)
        this.dcChangeHandler({ ...user, value: user.userId })
      })
    } else if (dcList.length > 0) {
      if (dcDefaultId > 0) {
        job.dc = dcDefaultId
      } else {
        job.dc = dcList[0].userId
      }
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.dc)
        this.dcChangeHandler({ ...user, value: user.userId })
      })
    } else {
      // job.dc = 0
      // job.dcDepartment = 0
      // job.dcOffice = 0
    }
    if (this.view.isHC) {
      // 操作
      if (opList.length > 0) {
        if (opDefaultId > 0) {
          job.op = opDefaultId
        } else {
          job.op = opList[0].userId
        }

        const user = await User.getUserById(job.op)
        this.view.$nextTick(() => {
          this.txtOPChangeHandler({ ...user, value: user.userId })
        })
      } else {
        // job.op = 0
        // job.opDepartment = 0
      }
      // 海外客服
      if (overseaOpList.length > 0) {
        if (overseaOpDefaultId > 0) {
          job.overseaOp = overseaOpDefaultId
        } else {
          job.overseaOp = overseaOpList[0].userId
        }

        const user = await User.getUserById(job.overseaOp)
        this.view.$nextTick(() => {
          this.overseaOpChangeHandler({ ...user, value: user.userId })
        })
      } else {
        // job.overseaOp = 0
        // job.overseaOpDepartment = 0
      }
    }
    // 自定义岗位1
    if (userDefinedRoleId1CargoSourceList.length > 0) {
      job.userDefinedRoleId1 = userDefinedRoleId1CargoSourceList[0].userId
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.userDefinedRoleId1)
        this.userDefinedRoleId1Handler({ ...user, value: user.userId })
      })
    } else if (userDefinedRoleId1List.length > 0) {
      job.userDefinedRoleId1 = userDefinedRoleId1 > 0 ? userDefinedRoleId1 : userDefinedRoleId1List[0].userId
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.userDefinedRoleId1)
        this.userDefinedRoleId1Handler({ ...user, value: user.userId })
      })
    } else {
      // job.userDefinedRoleId1 = 0
      // job.userDefinedRoleId1Department = 0
      // job.userDefinedRoleId1Office = 0
    }
    // 自定义岗位2
    if (userDefinedRoleId2CargoSourceList.length > 0) {
      job.userDefinedRoleId2 = userDefinedRoleId2CargoSourceList[0].userId
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.userDefinedRoleId2)
        this.userDefinedRoleId2Handler({ ...user, value: user.userId })
      })
    } else if (userDefinedRoleId2List.length > 0) {
      job.userDefinedRoleId2 = userDefinedRoleId2 > 0 ? userDefinedRoleId2 : userDefinedRoleId2List[0].userId
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.userDefinedRoleId2)
        this.userDefinedRoleId2Handler({ ...user, value: user.userId })
      })
    } else {
      // job.userDefinedRoleId2 = 0
      // job.userDefinedRoleId2Department = 0
      // job.userDefinedRoleId2Office = 0
    }
  }
  /**
   * 本地服务选择
   */
  loadingTermChange(fieldName) {
    const job = this.job
    if (fieldName === 'warehousing') {
      if (!job.warehousing) {
        job.warehouseCmp = 0
        if (!job.uuid && this.view.isCopy) { // 复制的时候,取消勾选，要清空
          job.warehouseInfo = []
          job.warehouseName = ''
          if (this.context && this.context.modifiedData && this.context.modifiedData.warehouseInfo) {
            this.context.modifiedData.warehouseInfo = []
          }
        }
      }
    } else if (fieldName === 'landTransportation') {
      if (!job.landTransportation) {
        job.carryingCmp = 0
        if (!job.uuid && this.view.isCopy) { // 复制的时候,取消勾选，要清空
          job.trucking = []
        }
      }
    }
  }

  /**
	 * 起运港修改
	 */
  async loadingPortCodeChange(data) {
    await super.loadingPortCodeChange(data)
    JobUtils.matchUserPortConfig(this.view, this.job)
    JobUtils.matchRegionWarehouseMappingConfig(this.job, warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData)
    JobUtils.loadingShipDate(this.job)
  }
}
